
    import './styles.scoped.css';
    export default {
  "placeholder": "awsui_placeholder_dwuol_13dzc_5",
  "item": "awsui_item_dwuol_13dzc_10",
  "checkbox": "awsui_checkbox_dwuol_13dzc_14",
  "filter": "awsui_filter_dwuol_13dzc_23",
  "trigger": "awsui_trigger_dwuol_13dzc_28",
  "layout-strut": "awsui_layout-strut_dwuol_13dzc_34",
  "list-bottom": "awsui_list-bottom_dwuol_13dzc_40"
};
  